import React, { useEffect, useState } from "react";
import { Row, Col, Form, Select, Button, Collapse, Dropdown, Menu, notification } from "antd";
import { ArrowDownOutlined, ArrowUpOutlined, SearchOutlined, CloseOutlined, WhatsAppOutlined, MoreOutlined, PrinterOutlined, EditOutlined } from "@ant-design/icons";
import moment from "moment";

import api from '../../services/api';
import { useStateValue } from '../../state';
import { linkApi } from "../../services/auth";
import { listagemActions, manutencaoActions } from "../../actions";
import { novaAbaNavegador } from "../../services/funcoes";
import { FormatNumber } from "../../ValueObjects";
import { BreadcrumbPage, FiltroSearch, ComboData, TabelaDados, Data, SelectPaginacao } from "../../components";
import { ModalEnvioBolWhats, ModalEditarBoleto } from "../../components/modals/";

export default function Boleto() {

    const [{ ui, manutencao }, dispatch] = useStateValue();
    const [formulario] = Form.useForm();
    const [openPesquisaAvancada, setOpenPesquisaAvancada] = useState(false);
    const [openModalEnvioBolWhats, setOpenModalEnvioBolWhats] = useState(false);
    const [openModalEditarBoleto, setOpenModalEditarBoleto] = useState(false);
    const [parametrosLocal, setParametrosLocal] = useState({});
    const [parametrosWhats, setParametrosWhats] = useState({});

    const togglePesquisa = () => {
        setOpenPesquisaAvancada(!openPesquisaAvancada);
    };
    useEffect(() => {
        let sql = "";
        sql += !!formulario.getFieldValue().BancoId ? `&ban_id=${formulario.getFieldValue().BancoId}` : "";
        sql += !!formulario.getFieldValue().ClienteId ? `&ClienteId=${formulario.getFieldValue().ClienteId}` : "";
        sql += !!formulario.getFieldValue().dataInicial ? `&DataInicial=${moment(formulario.getFieldValue().dataInicial).format('YYYY-MM-DD')}` : `&DataInicial=${moment(new Date()).format('YYYY-MM-DD')}`;
        sql += !!formulario.getFieldValue().dataFinal ? `&DataFinal=${moment(formulario.getFieldValue().dataFinal).format('YYYY-MM-DD')}` : `&DataFinal=${moment(new Date).format('YYYY-MM-DD')}`;
        dispatch({ type: listagemActions.CHANGE, data: { outrosFiltros: `${sql}`, ordem: '-bol_dataemissao' } });
        formulario.setFieldsValue({ dataEmissao: moment(new Date()) });
        verificarTelefone();
    }, []);

    function aplicarFiltrosAvancados() {
        let sql = "";
        sql += !!formulario.getFieldValue().BancoId ? `&ban_id=${formulario.getFieldValue().BancoId}` : "";
        sql += !!formulario.getFieldValue().ClienteId ? `&ClienteId=${formulario.getFieldValue().ClienteId}` : "";
        sql += !!formulario.getFieldValue().dataInicial ? `&DataInicial=${moment(formulario.getFieldValue().dataInicial).format('YYYY-MM-DD')}` : `&DataInicial=${moment(new Date()).format('YYYY-MM-DD')}`;
        sql += !!formulario.getFieldValue().dataFinal ? `&DataFinal=${moment(formulario.getFieldValue().dataFinal).format('YYYY-MM-DD')}` : `&DataFinal=${moment(new Date).format('YYYY-MM-DD')}`;
        dispatch({ type: listagemActions.CHANGE, data: { outrosFiltros: `${sql}`, ordem: '-bol_dataemissao' } });
    };

    function RemoverFiltrosAvancados() {
        formulario.resetFields(['BancoId', 'ClienteId', 'dataFinal', 'dataInicial']);
    };

    async function verificarTelefone() {
        let verificaTelefone = (await api.get(`ParametroLocal/BuscarParametros`)).data;
        setParametrosLocal(verificaTelefone);
    }

    function imprimirBoleto(record) {
        if (!!record.bol_id) {
            novaAbaNavegador(`Boleto/Gerar/${record.bol_id}`);
        }
    };

    async function abrirEnvioWhats(record) {
        if (typeof parametrosLocal?.par_numerowhatsapp === "string" && parametrosLocal.par_numerowhatsapp.trim() !== "") {
            let dados = {
                ntf_dataemissao: record.bol_dataemissao,
                valortotalnota: record.bol_valor,
                ntf_nomedest: record.pes_nome
            };
            let novoRecord = { ...record, ...dados };
            setParametrosWhats(novoRecord);
            setOpenModalEnvioBolWhats(true);
        } else {
            notification.info({ message: 'Operação não permitida', description: "Cliente sem telefone cadastrado nas Configurações do Local!" });
            return;
        }
    };

    async function editarBoleto(record) {
        let teste = record.bol_id;
        let existeRemessa = (await api.get(`RemessaBoleto/VerificaRemessa?bol_id=${teste}`)).data;
        if (existeRemessa === true) {
            notification.warning({ description: 'Boleto possui Remessa!', message: 'AVISO!' });
            return;
        }
        let filtros = "";
        let dataFiltro = moment(record.bol_dataemissao).format("YYYY-MM-DD");
        if (!!dataFiltro) {
            filtros += `DataInicial=${dataFiltro}&DataFinal=${dataFiltro}`
            filtros += `&ntf_id=${record.ntf_id}`
        }
        if (!!record.ntf_id && !!!dataFiltro) {
            filtros += `ntf_id=${record.ntf_id}`
        }
        let dados = (await api.get(`Boleto/Listar?${filtros}`)).data;
        dispatch({ type: manutencaoActions.CHANGE, data: { dados: dados.items } })
        setOpenModalEditarBoleto(true);
    };

    function recarregarLista() {
        dispatch({ type: listagemActions.CHANGE, data: { ordem: '-ntf_dataemissao' } });
    };

    function menuTable(record) {
        const items = [
            {
                key: '1',
                label: (
                    <Button type="text" icon={<WhatsAppOutlined />} onClick={() => abrirEnvioWhats(record)}>Enviar por WhatsApp</Button>
                )
            },
            {
                key: '2',
                label: (
                    <Button type="text" icon={<PrinterOutlined />} onClick={() => imprimirBoleto(record)}>imprimir Boleto</Button>
                )
            },
            {
                key: '3',
                label: (
                    <Button type="text" icon={<EditOutlined />} onClick={() => editarBoleto(record)}>Editar</Button>
                )
            }
        ];

        return { items };
    }

    return (
        <div className="p-10">
            <Row align="middle" justify="space-between" gutter={[8, 8]}>
                <Col>
                    <BreadcrumbPage placeholder="Cliente, Codigo, N° Doc." />
                </Col>
            </Row>
            <Form layout="vertical" form={formulario}>
                <Row gutter={[8, 0]}>
                    <Col xs={24} sm={24} md={24} lg={18} xl={19} xxl={20}>
                        <Row gutter={[8, 0]}>
                            <Col xs={24} sm={17} md={17} lg={18} xl={20} xxl={20}>
                                <FiltroSearch />
                            </Col>
                            <Col xs={24} sm={7} md={7} lg={4} xl={4} xxl={3}>
                                <ComboData form={formulario} eventoAoAlterar={() => {
                                    formulario.setFieldsValue({ DataFinal: moment(new Date()) });
                                    formulario.setFieldsValue({ DataInicial: moment(formulario.getFieldValue().dataPesquisa) });
                                    formulario.setFieldsValue({ dataFinal: moment(new Date()) });
                                    formulario.setFieldsValue({ dataInicial: moment(formulario.getFieldValue().dataPesquisa) });
                                    aplicarFiltrosAvancados();
                                }} />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row align="middle" gutter={[8, 8]}>
                    <Col span={24}>
                        <Collapse className="p-relative topDif" accordion ghost destroyInactivePanel={true}>
                            <div className="colDet"></div>
                            <Collapse.Panel key="1" showArrow={false} extra={
                                <Button type="primary" onClick={togglePesquisa} block>
                                    {openPesquisaAvancada ? <ArrowUpOutlined /> : <ArrowDownOutlined />} Realizar pesquisa avançada
                                </Button>
                            }>
                                <Row align="middle" gutter={[8, 0]}>
                                    <Col xs={24} sm={12} md={5} lg={4} xl={4} xxl={3}>
                                        <Data label="Data Emissão Incial" name="dataInicial" />
                                    </Col>
                                    <Col xs={24} sm={12} md={5} lg={4} xl={4} xxl={3}>
                                        <Data label="Data Emissão Final" name="dataFinal" />
                                    </Col>
                                    <Col xs={24} sm={12} md={7} lg={8} xl={5} xxl={7}>
                                        <Form.Item label="Cliente" name="ClienteId">
                                            <SelectPaginacao url="Cliente/ListarClientesAtivos?filtro=&ordem=%2Bpes_nome" placeholder="Selecione o Cliente" form={formulario}
                                                nameValue="ClienteId" nameLabel="pes_nome"
                                                conteudo={
                                                    cliente => (<Select.Option label={cliente.pes_nome} key={cliente.pes_id} value={cliente.pes_id}>{cliente.pes_nome}</Select.Option>)} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12} md={7} lg={8} xl={5} xxl={6}>
                                        <Form.Item label="Banco" name="BancoId">
                                            <SelectPaginacao url="Banco/Listar?filtro=&ordem=%2Bban_descricao" placeholder="Selecione o Banco" form={formulario} nameValue="BancoId" nameLabel="ban_descricao"
                                                conteudo={
                                                    banco => (<Select.Option label={banco.ban_descricao} Key={banco.ban_id} value={banco.ban_id}> {`${banco.ban_id} - ${banco.ban_descricao}`}</Select.Option>)} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={6} xxl={5} className="t-mob tm5">
                                        <Row gutter={[8, 8]} justify="end" className="tt-5">
                                            <Col xs={24} sm={12} md={6} lg={5} xl={12}>
                                                <Button icon={<CloseOutlined />} onClick={() => RemoverFiltrosAvancados()} block>
                                                    Remover Filtros
                                                </Button>
                                            </Col>
                                            <Col xs={24} sm={12} md={6} lg={5} xl={12}>
                                                <Button type="primary" icon={<SearchOutlined />} onClick={() => aplicarFiltrosAvancados()} block>
                                                    Aplicar Filtros
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Collapse.Panel>
                        </Collapse>
                    </Col>
                </Row>
            </Form>
            <div className="tabela">
                <TabelaDados url="Boleto/Listar" colunas={
                    [
                        {
                            title: '',
                            align: 'center',
                            width: 80,
                            render: ({ ban_id, ban_descricao }) => (
                                <div>
                                    <img className="imgLogoListaBanco" src={`${linkApi}Banco/RetornaLogo/${ban_id}`} alt={ban_descricao} />
                                </div>
                            ),
                        },
                        {
                            title: 'Informações',
                            render: ({ pes_nome, ser_serie, ntf_numero, prc_numeroparcela, bol_numerodocumento }) => (
                                <div>
                                    <Row align="middle">
                                        <Col>
                                            <b>{pes_nome}</b>
                                        </Col>
                                    </Row>
                                    <Row align="middle" gutter={[8, 0]}>
                                        <Col>
                                            Nº Doc.: <b>{bol_numerodocumento}</b>
                                        </Col>
                                        <Col>
                                            Parcela: <b>{prc_numeroparcela}</b>
                                        </Col>
                                    </Row>
                                </div>
                            ),
                        },
                        {
                            title: 'Data Emissão',
                            align: 'center',
                            render: ({ bol_dataemissao }) => (
                                <div>
                                    <b>{moment(bol_dataemissao).format('DD/MM/YYYY')}</b>
                                </div>
                            ),
                        },
                        {
                            title: 'Data Vencimento',
                            align: 'center',
                            render: ({ bol_datavencimento }) => (
                                <div>
                                    <b>{moment(bol_datavencimento).format('DD/MM/YYYY')}</b>
                                </div>
                            ),
                        },
                        {
                            title: 'Valor (R$)',
                            align: 'right',
                            render: ({ bol_valor }) => (
                                <div>
                                    <b className="f-18">{FormatNumber(bol_valor, true)}</b>
                                </div>
                            ),
                        },
                        {
                            title: 'Ações',
                            dataIndex: '',
                            key: 'x',
                            width: 65,
                            align: 'center',
                            render: (record) => (
                                <div>
                                    <Row align="middle" justify="center" gutter={[5, 0]}>
                                        <Col>
                                            <Dropdown menu={menuTable(record)} trigger={['click']}>
                                                <Button onClick={e => e.preventDefault()} icon={<MoreOutlined />} />
                                            </Dropdown>
                                        </Col>
                                    </Row>
                                </div>
                            ),
                        },
                    ]
                } />
            </div>
            <ModalEnvioBolWhats exibirModalEnvioBolWhats={openModalEnvioBolWhats} parametrosWhats={parametrosWhats} fecharModalEnvioBolWhats={() => { setOpenModalEnvioBolWhats(false); recarregarLista(); }} />
            <ModalEditarBoleto exibirModalEditarBoleto={openModalEditarBoleto} fecharModalEditarBoleto={() => { setOpenModalEditarBoleto(false); recarregarLista(); }} forma={formulario} />
        </div>
    );

}